import React, { useState } from 'react';
import { 
  FaGem, 
  FaStar, 
  FaArrowRight, 
  FaFire, 
  FaNewspaper, 
  FaHeart, 
  FaEye, 
  FaShoppingBag, 
  FaRegGem,
  FaRing,
  FaCrown,
  FaTimes,
  FaCheckCircle,
  FaTruck,
  FaShieldAlt,
  FaExchangeAlt,
  FaStore,
  FaMapMarkerAlt,
  FaClock
} from 'react-icons/fa';

const CuratedClassics = () => {
  const [activeCategory, setActiveCategory] = useState('earrings');
  const [hoveredCard, setHoveredCard] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showModal, setShowModal] = useState(false);

  // 5 categories
  const categories = [
    { id: 'earrings', name: 'Earrings', icon: <FaGem className="w-3.5 h-3.5" />, color: 'from-pink-500 to-purple-600' },
    { id: 'bangles', name: 'Bangles', icon: <FaRing className="w-3.5 h-3.5" />, color: 'from-purple-500 to-pink-500' },
    { id: 'diamond', name: 'Diamond', icon: <FaCrown className="w-3.5 h-3.5" />, color: 'from-amber-500 to-amber-600' },
    { id: 'bestsellers', name: 'Best Sellers', icon: <FaFire className="w-3.5 h-3.5" />, color: 'from-pink-600 to-purple-700' },
    { id: 'new', name: "What's New", icon: <FaNewspaper className="w-3.5 h-3.5" />, color: 'from-purple-600 to-pink-600' },
  ];

  const products = {
    earrings: [
      { id: 1, name: "Pearl Drop Earrings", image: "https://tse4.mm.bing.net/th/id/OIP.mYF07eTMkckN72WpYrE2BQHaHa?rs=1&pid=ImgDetMain&o=7&rm=3", quality1: "Freshwater Pearls", quality2: "Hypoallergenic", rating: 5, reviews: 128, description: "Beautiful pearl drop earrings crafted with real freshwater pearls. These elegant earrings feature a classic design that complements both casual and formal wear. The hypoallergenic material ensures comfort for all-day wear.", material: "Freshwater Pearls, 18K Gold Plated", care: "Wipe with soft cloth, avoid contact with chemicals", offlineOnly: true, storeLocations: ["Mumbai - Andheri", "Delhi - CP", "Bangalore - Indiranagar"] },
      { id: 2, name: "Gold Hoop Earrings", image: "https://i.ebayimg.com/images/g/6aIAAOSwfwllmAI3/s-l1600.jpg", quality1: "18K Gold Plated", quality2: "Lightweight", rating: 5, reviews: 89, description: "Classic gold hoop earrings with a modern twist. Lightweight design makes them perfect for daily wear. The 18K gold plating gives a luxurious shine that lasts.", material: "18K Gold Plated, Brass Base", care: "Store in a dry place, avoid moisture", offlineOnly: true, storeLocations: ["Mumbai - Andheri", "Delhi - CP"] },
      { id: 3, name: "Jhumka Earrings", image: "https://tse1.mm.bing.net/th/id/OIP.eGAe3Lhm5JvwSGjFq23D3QHaHa?w=1000&h=1000&rs=1&pid=ImgDetMain&o=7&rm=3", quality1: "Traditional", quality2: "Antique Finish", rating: 4, reviews: 245, description: "Traditional Indian Jhumka earrings with intricate detailing. The antique finish adds a vintage charm that makes these earrings perfect for festive occasions and weddings.", material: "Brass with Antique Finish, Glass Stones", care: "Keep away from perfumes and water", offlineOnly: true, storeLocations: ["Mumbai - Andheri", "Delhi - CP", "Bangalore - Indiranagar", "Chennai - T Nagar"] },
      { id: 4, name: "Chandelier Earrings", image: "https://tse1.mm.bing.net/th/id/OIP.9tNtQz85TDbPz_1BnBlYYwHaKB?rs=1&pid=ImgDetMain&o=7&rm=3", quality1: "Party Wear", quality2: "Crystal Stones", rating: 5, reviews: 67, description: "Stunning chandelier earrings adorned with sparkling crystal stones. Designed to make you shine at parties and special events. The lightweight design ensures comfort without compromising on style.", material: "Cubic Zirconia, Silver Plated", care: "Clean with jewelry polish, avoid harsh chemicals", offlineOnly: true, storeLocations: ["Mumbai - Andheri", "Delhi - CP"] },
    ],
    bangles: [
      { id: 5, name: "Gold Bangles Set", image: "https://tse2.mm.bing.net/th/id/OIP.0V0XHcJb7oMa4CWLY-ysigHaHU?rs=1&pid=ImgDetMain&o=7&rm=3", quality1: "Hallmarked Gold", quality2: "Lifetime Exchange", rating: 5, reviews: 156, description: "Luxurious gold bangles set featuring hallmarked quality. Comes with lifetime exchange warranty. Perfect for weddings and special occasions.", material: "22K Hallmarked Gold", care: "Store in original box, clean with gold polish", offlineOnly: true, storeLocations: ["Mumbai - Andheri", "Delhi - CP"] },
      { id: 6, name: "Kada Bangles", image: "https://th.bing.com/th/id/R.4c5388bc392cfec43e6a36160d9a9d44?rik=%2fJz%2fBhD5rZ9etw&riu=http%3a%2f%2f2.bp.blogspot.com%2f-R5mf8GxOOFc%2fURa9T3pj8zI%2fAAAAAAAADug%2fgB57Y3rGmmU%2fs1600%2fkada.jpg&ehk=stWzuSOwL673e7D%2b4Fz9%2bDmWhwzQtbNlIoZfKlNIq0U%3d&risl=&pid=ImgRaw&r=0", quality1: "Heavy Design", quality2: "Wedding Special", rating: 4, reviews: 94, description: "Traditional Kada bangles with heavy design. Specially crafted for wedding ceremonies and grand celebrations. The intricate patterns showcase exceptional craftsmanship.", material: "German Silver, Gold Plated", care: "Wipe with soft cloth after use", offlineOnly: true, storeLocations: ["Mumbai - Andheri", "Delhi - CP", "Bangalore - Indiranagar"] },
      { id: 7, name: "Thin Bangles", image: "https://www.deutschhouston.com/upload/product/B7580G.jpg", quality1: "Daily Wear", quality2: "Light Weight", rating: 4, reviews: 78, description: "Elegant thin bangles perfect for daily wear. Lightweight and comfortable design allows you to wear them all day without any discomfort.", material: "Alloy with Gold Polish", care: "Avoid water contact, store in dry place", offlineOnly: true, storeLocations: ["All Stores"] },
      { id: 8, name: "Designer Bangles", image: "https://th.bing.com/th/id/OIP.s90SGfueLWrzekm8CEvlZwHaJk?o=7rm=3&rs=1&pid=ImgDetMain&o=7&rm=3", quality1: "Latest Design", quality2: "Trendy", rating: 5, reviews: 112, description: "Contemporary designer bangles featuring trendy patterns. These bangles are crafted to keep you ahead in fashion. The unique design sets you apart from the crowd.", material: "Brass with Enamel Work", care: "Store separately to avoid scratches", offlineOnly: true, storeLocations: ["Mumbai - Andheri", "Delhi - CP"] },
    ],
    diamond: [
      { id: 9, name: "Diamond Ring", image: "https://assets.marthastewartweddings.com/styles/wmax-520-highdpi/d26/limor_rg8310993w_flat_ring/limor_rg8310993w_flat_ring_vert.jpg?itok=rak-tati", quality1: "IGI Certified", quality2: "Solitaire", rating: 5, reviews: 67, description: "Exquisite solitaire diamond ring with IGI certification. The brilliant cut diamond sparkles from every angle. Perfect for engagements and anniversaries.", material: "0.5 Carat Diamond, 18K White Gold", care: "Professional cleaning recommended every 6 months", offlineOnly: true, storeLocations: ["Mumbai - Andheri", "Delhi - CP"] },
      { id: 10, name: "Diamond Pendant", image: "https://www.divourdiamonds.com/upload/product/RPN-005-1-WG.jpg", quality1: "0.5 Carat", quality2: "Matching Chain", rating: 5, reviews: 45, description: "Beautiful diamond pendant with matching chain. The timeless design makes it a versatile piece for any occasion. Comes with a complimentary chain.", material: "0.5 Carat Diamond, Silver Chain", care: "Clean with mild soap and soft brush", offlineOnly: true, storeLocations: ["Mumbai - Andheri", "Delhi - CP", "Bangalore - Indiranagar"] },
      { id: 11, name: "Diamond Earrings", image: "https://www.mavilo.com/cdn/shop/files/Round_1_Eternity_3.95CT_Hoop_Earrings.jpg?v=1706823353", quality1: "VS Clarity", quality2: "E-F Color", rating: 5, reviews: 34, description: "Premium diamond earrings with VS clarity and E-F color grade. Each diamond is carefully selected for maximum brilliance. The setting ensures secure fit.", material: "1 Carat Total Weight, Platinum Setting", care: "Store in jewelry box, avoid ultrasonic cleaners", offlineOnly: true, storeLocations: ["Mumbai - Andheri", "Delhi - CP"] },
      { id: 12, name: "Diamond Nose Pin", image: "https://www.tanishq.co.in/on/demandware.static/-/Sites-Tanishq-product-catalog/default/dw73f3ac6a/images/hi-res/502614OCRABA02_1.jpg", quality1: "Real Diamond", quality2: "Daily Wear", rating: 4, reviews: 89, description: "Elegant diamond nose pin for everyday elegance. The secure screw-back design ensures it stays in place throughout the day.", material: "0.1 Carat Diamond, 14K Gold", care: "Clean with soft toothbrush and mild soap", offlineOnly: true, storeLocations: ["All Stores"] },
    ],
    bestsellers: [
      { id: 13, name: "Best Seller Ring", image: "https://www.parisjewellers.com/wp-content/uploads/2025/03/rin-ler-0075-300x300.jpg", quality1: "Top Rated", quality2: "Favorite", rating: 5, reviews: 890, description: "Our best-selling ring loved by thousands of customers. The perfect combination of style and affordability makes it a customer favorite.", material: "Cubic Zirconia, Sterling Silver", care: "Avoid harsh chemicals, store in pouch", offlineOnly: true, storeLocations: ["All Stores"] },
      { id: 14, name: "Popular Necklace", image: "https://tse2.mm.bing.net/th/id/OIP.LaOKw9ky5P6p8oonFB7klgHaE8?rs=1&pid=ImgDetMain&o=7&rm=3", quality1: "Most Loved", quality2: "Best Value", rating: 5, reviews: 678, description: "The most popular necklace in our collection. Excellent value for money with premium quality. A must-have accessory for every jewelry lover.", material: "Gold Plated, Natural Stones", care: "Wipe with soft cloth after each use", offlineOnly: true, storeLocations: ["Mumbai - Andheri", "Delhi - CP", "Bangalore - Indiranagar"] },
      { id: 15, name: "Trending Earrings", image: "https://tse1.mm.bing.net/th/id/OIP.etojBWrw8GRA03ekRo7IQgHaJQ?w=2400&h=3000&rs=1&pid=ImgDetMain&o=7&rm=3", quality1: "Viral Style", quality2: "Instagram Famous", rating: 5, reviews: 789, description: "Viral earrings trending on social media. Get the look that everyone is talking about. These statement earrings will make you stand out.", material: "Resin with Gold Accents", care: "Keep away from heat, clean with damp cloth", offlineOnly: true, storeLocations: ["All Stores"] },
      { id: 16, name: "Hot Deal Bangles", image: "https://th.bing.com/th/id/R.60d3c4d259b65b257188e187b461f73b?rik=9S8iwGP4ztEcnA&riu=http%3a%2f%2flh3.googleusercontent.com%2f-upsdWVapazQ%2fVYodOKfyT-I%2fAAAAAAAAJtg%2f5KEOe9f0DhA%2fs1600%2fFB_IMG_1435112082974.jpg&ehk=%2bEez%2fXIs%2bbykmdxkSTQwZLUkn7pR6%2bkFnzQjZGrKaH0%3d&risl=&pid=ImgRaw&r=0", quality1: "Limited", quality2: "Fast Selling", rating: 4, reviews: 567, description: "Limited edition bangles selling fast. Grab yours before they're gone. The unique design and premium quality make these a must-have.", material: "Alloy with Antique Finish", care: "Avoid moisture, store in dry box", offlineOnly: true, storeLocations: ["Mumbai - Andheri", "Delhi - CP"] },
    ],
    new: [
      { id: 17, name: "New Arrival Ring", image: "https://images.unsplash.com/photo-1605100804763-247f67b3557e?w=400&h=400&fit=crop", quality1: "Just Launched", quality2: "Fresh Design", rating: 5, reviews: 45, description: "Fresh new design just launched. Be the first to own this unique piece. The contemporary style appeals to modern fashion enthusiasts.", material: "Stainless Steel, Lab Grown Gem", care: "Easy care, water resistant", offlineOnly: true, storeLocations: ["Mumbai - Andheri", "Delhi - CP"] },
      { id: 18, name: "Latest Necklace", image: "https://i.pinimg.com/736x/95/67/e0/9567e05dddbf3cb5dde1f897dfa4cf0c.jpg", quality1: "New Collection", quality2: "Modern Look", rating: 5, reviews: 34, description: "Latest addition to our new collection. Modern design with a classic touch. Perfect for those who love staying ahead of fashion trends.", material: "Rose Gold Plated, Cubic Zirconia", care: "Store in provided box when not wearing", offlineOnly: true, storeLocations: ["All Stores"] },
      { id: 19, name: "Fresh Collection", image: "https://assets.telegraphindia.com/telegraph/2023/Feb/1676116867_new-project-100.jpg", quality1: "Season Special", quality2: "Limited", rating: 4, reviews: 56, description: "Season special collection piece. Limited edition design that captures the essence of current fashion trends.", material: "Mixed Metals with Enamel", care: "Gentle cleaning with soft cloth", offlineOnly: true, storeLocations: ["Mumbai - Andheri", "Bangalore - Indiranagar"] },
      { id: 20, name: "Modern Earrings", image: "https://th.bing.com/th/id/OIP.eu1ZD50ICMS_qDsDX20cMAHaHa?o=7rm=3&rs=1&pid=ImgDetMain&o=7&rm=3", quality1: "Contemporary", quality2: "Unique", rating: 5, reviews: 78, description: "Contemporary earrings with unique geometric design. Stand out with these modern statement pieces. Lightweight and comfortable for all-day wear.", material: "Titanium Steel, Acrylic", care: "Wipe clean with soft cloth", offlineOnly: true, storeLocations: ["All Stores"] },
    ],
  };

  const currentProducts = products[activeCategory] || products.earrings;

  const handleViewDetails = (product) => {
    setSelectedProduct(product);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedProduct(null);
  };

  return (
    <div className="py-8 md:py-12 bg-gradient-to-br from-purple-50 via-pink-50 to-amber-50">
      <div className="container mx-auto px-2 max-w-7xl">
        {/* Header */}
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">
            Curated <span className="bg-gradient-to-r from-purple-600 via-pink-600 to-amber-600 bg-clip-text text-transparent">Classics</span>
          </h2>
          <div className="w-16 h-0.5 bg-gradient-to-r from-purple-500 via-pink-500 to-amber-500 mx-auto rounded-full"></div>
          <p className="text-gray-600 text-sm mt-2 max-w-md mx-auto">
            Discover timeless elegance — <span className="font-semibold text-purple-600">In-Store Collection</span>
          </p>
        </div>

        {/* Categories */}
        <div className="flex justify-center mb-8">
          <div className="flex flex-wrap justify-center gap-1.5">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setActiveCategory(category.id)}
                className={`group flex items-center gap-1 px-3 py-1 rounded-full font-medium transition-all duration-300 ${
                  activeCategory === category.id
                    ? `bg-gradient-to-r ${category.color} text-white shadow-md shadow-purple-200`
                    : 'bg-white text-gray-600 hover:bg-gradient-to-r hover:from-purple-50 hover:to-pink-50 hover:text-purple-600 shadow-sm border border-gray-200'
                }`}
              >
                <span className="text-sm">{category.icon}</span>
                <span className="text-xs whitespace-nowrap font-medium">{category.name}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {currentProducts.map((product) => (
            <div
              key={product.id}
              className="group"
              onMouseEnter={() => setHoveredCard(product.id)}
              onMouseLeave={() => setHoveredCard(null)}
            >
              <div className="bg-white rounded-lg shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden border border-gray-100 h-full flex flex-col">
                
                {/* Image Section */}
                <div className="relative w-full bg-gradient-to-br from-purple-50/50 via-pink-50/50 to-amber-50/50 flex items-center justify-center p-1.5 overflow-hidden" style={{ height: '180px' }}>
                  <img 
                    src={product.image} 
                    alt={product.name}
                    className="w-full h-full object-contain transition-transform duration-500 group-hover:scale-105"
                    style={{ objectFit: 'contain', maxWidth: '100%', maxHeight: '100%' }}
                  />

                  {/* Hover Actions */}
                  <div className={`absolute inset-0 bg-gradient-to-br from-purple-600/20 to-pink-600/20 backdrop-blur-[2px] flex items-center justify-center gap-1.5 transition-all duration-300 ${
                    hoveredCard === product.id ? 'opacity-100 visible' : 'opacity-0 invisible'
                  }`}>
                    <button className="bg-white p-1.5 rounded-full hover:bg-gradient-to-r hover:from-purple-600 hover:to-pink-600 hover:text-white transition-all duration-300 transform hover:scale-110 shadow-md text-gray-700">
                      <FaHeart className="w-3.5 h-3.5" />
                    </button>
                    <button className="bg-white p-1.5 rounded-full hover:bg-gradient-to-r hover:from-purple-600 hover:to-pink-600 hover:text-white transition-all duration-300 transform hover:scale-110 shadow-md text-gray-700">
                      <FaEye className="w-3.5 h-3.5" />
                    </button>
                  </div>
                </div>

                {/* Info Section */}
                <div className="p-2 flex-1 flex flex-col">
                  <h3 className="font-semibold text-gray-800 text-sm leading-tight mb-1 group-hover:text-purple-600 transition-colors line-clamp-1">
                    {product.name}
                  </h3>
                  
                  {/* Rating */}
                  <div className="flex items-center gap-1 mb-2">
                    <div className="flex">
                      {[...Array(5)].map((_, i) => (
                        <FaStar 
                          key={i} 
                          className={`w-3 h-3 ${i < product.rating ? 'text-amber-400 fill-current' : 'text-gray-300'}`} 
                        />
                      ))}
                    </div>
                    <span className="text-[10px] text-gray-500">({product.reviews})</span>
                  </div>

                  {/* Quality Lines */}
                  <div className="mb-3 space-y-1 flex-1">
                    <div className="flex items-center gap-1">
                      <FaRegGem className="w-2.5 h-2.5 text-purple-500 flex-shrink-0" />
                      <p className="text-[11px] text-gray-600 truncate">{product.quality1}</p>
                    </div>
                    <div className="flex items-center gap-1">
                      <FaRegGem className="w-2.5 h-2.5 text-pink-500 flex-shrink-0" />
                      <p className="text-[11px] text-gray-600 truncate">{product.quality2}</p>
                    </div>
                  </div>
                  
                  {/* View Button */}
                  <button 
                    onClick={() => handleViewDetails(product)}
                    className="w-full bg-gradient-to-r from-purple-50 to-pink-50 text-purple-700 py-1.5 rounded-md text-xs font-medium hover:from-purple-600 hover:to-pink-600 hover:text-white transition-all duration-300 flex items-center justify-center gap-1.5 border border-purple-200 hover:border-transparent"
                  >
                    <span>View Details</span>
                    <FaShoppingBag className="w-3 h-3" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Product Details Modal */}
      {showModal && selectedProduct && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm animate-fadeIn">
          <div className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto shadow-2xl border border-gray-200 animate-slideUp">
            {/* Modal Header */}
            <div className="sticky top-0 bg-white p-4 border-b border-gray-200 flex justify-between items-center">
              <h3 className="text-xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
                Product Details
              </h3>
              <button 
                onClick={closeModal}
                className="text-gray-400 hover:text-gray-600 transition-colors p-1 rounded-full hover:bg-gray-100"
              >
                <FaTimes className="w-5 h-5" />
              </button>
            </div>

            {/* Modal Body */}
            <div className="p-6">
              <div className="grid md:grid-cols-2 gap-6">
                {/* Product Image */}
                <div className="bg-gradient-to-br from-purple-50/50 via-pink-50/50 to-amber-50/50 rounded-xl p-4 flex items-center justify-center">
                  <img 
                    src={selectedProduct.image} 
                    alt={selectedProduct.name}
                    className="w-full max-h-80 object-contain rounded-lg"
                  />
                </div>

                {/* Product Info */}
                <div className="space-y-4">
                  <div>
                    <div className="flex items-center gap-2 mb-2">
                      <div className="flex">
                        {[...Array(5)].map((_, i) => (
                          <FaStar key={i} className={`w-3.5 h-3.5 ${i < selectedProduct.rating ? 'text-amber-400' : 'text-gray-300'}`} />
                        ))}
                      </div>
                      <span className="text-xs text-gray-500">({selectedProduct.reviews} reviews)</span>
                    </div>
                    <h2 className="text-2xl font-bold text-gray-800 mb-2">{selectedProduct.name}</h2>
                  </div>

                  {/* Store Availability Card */}
                  <div className="bg-gradient-to-r from-orange-50 to-amber-50 rounded-xl p-3 border border-orange-200">
                    <div className="flex items-center gap-2 mb-2">
                      <div className="bg-orange-500 p-1 rounded-full">
                        <FaStore className="w-3 h-3 text-white" />
                      </div>
                      <span className="font-bold text-gray-800 text-sm">Available at Physical Stores</span>
                    </div>
                    <p className="text-xs text-gray-600 mb-2">
                      This exquisite piece is available for in-store purchase. 
                      Experience the luxury firsthand at our showrooms.
                    </p>
                    <div className="flex items-start gap-2 mt-2">
                      <FaMapMarkerAlt className="w-3.5 h-3.5 text-orange-600 mt-0.5" />
                      <div>
                        <p className="text-xs font-semibold text-gray-700">Store Locations:</p>
                        <div className="flex flex-wrap gap-1 mt-1">
                          {selectedProduct.storeLocations?.map((location, idx) => (
                            <span key={idx} className="text-[10px] bg-white px-2 py-0.5 rounded-full text-gray-600 border border-gray-200">
                              {location}
                            </span>
                          ))}
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center gap-2 mt-2 pt-2 border-t border-orange-200">
                      <FaClock className="w-3 h-3 text-orange-600" />
                      <span className="text-[10px] text-gray-500">Visit us: 11 AM - 8 PM, All Days</span>
                    </div>
                  </div>

                  <div className="border-t border-gray-200 pt-3">
                    <p className="text-gray-600 text-sm leading-relaxed">
                      {selectedProduct.description}
                    </p>
                  </div>

                  <div className="space-y-2">
                    <div className="flex items-start gap-2">
                      <FaCheckCircle className="w-4 h-4 text-green-500 mt-0.5" />
                      <div>
                        <p className="text-gray-800 text-sm font-medium">Material</p>
                        <p className="text-gray-500 text-xs">{selectedProduct.material}</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-2">
                      <FaShieldAlt className="w-4 h-4 text-blue-500 mt-0.5" />
                      <div>
                        <p className="text-gray-800 text-sm font-medium">Care Instructions</p>
                        <p className="text-gray-500 text-xs">{selectedProduct.care}</p>
                      </div>
                    </div>
                  </div>

                  <div className="flex gap-3 pt-2">
                    <button className="flex-1 bg-gradient-to-r from-orange-500 to-amber-500 text-white py-2.5 rounded-lg font-semibold text-sm hover:shadow-lg transition-all duration-300 flex items-center justify-center gap-2">
                      <FaMapMarkerAlt className="w-4 h-4" />
                      Find Nearest Store
                    </button>
                    <button className="px-4 py-2.5 bg-gray-100 text-gray-600 rounded-lg hover:bg-gray-200 transition-all duration-300">
                      <FaHeart className="w-4 h-4" />
                    </button>
                  </div>

                  <div className="flex gap-4 pt-2 text-xs text-gray-500">
                    <div className="flex items-center gap-1">
                      <FaTruck className="w-3 h-3" />
                      <span>In-Store Pickup</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <FaExchangeAlt className="w-3 h-3" />
                      <span>30 Day Returns</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <FaShieldAlt className="w-3 h-3" />
                      <span>Lifetime Exchange*</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <style jsx>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes slideUp {
          from { 
            opacity: 0;
            transform: translateY(30px);
          }
          to { 
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out;
        }
        .animate-slideUp {
          animation: slideUp 0.3s ease-out;
        }
      `}</style>
    </div>
  );
};

export default CuratedClassics;